interface WithGameCode {
  gameCode?: string;
}

/**
 * A to Z by game code, ignoring case, with numbers in numeric order (3 before
 * 14). Whole-skin failures have no game and go last.
 */
export const byGameCode = (a: WithGameCode, b: WithGameCode) => {
  if (a.gameCode === undefined || b.gameCode === undefined) {
    return Number(a.gameCode === undefined) - Number(b.gameCode === undefined);
  }
  return a.gameCode.localeCompare(b.gameCode, undefined, { sensitivity: "base", numeric: true });
};
